// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__392MA","name":"styles_name__33PKQ","phone":"styles_phone__37eb4"};